module.exports = __webpack_public_path__ + "img/icon-warning-stormsurge-orange.5f7a15d4.svg";